import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BackendService,
  HttpOptions,
  PaginatedResponseModel,
} from '@ipg/ngx-frontend-toolset';
import { Download } from '../downloads.model';

@Injectable({
  providedIn: 'root',
})
export class DownloadsService {
  private readonly _backend = inject(BackendService);

  getAll(options?: HttpOptions): Observable<PaginatedResponseModel<Download[]>> {
    return this._backend.get('/downloads', options);
  }
}
